var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ValidationProvider", {
    ref: "numericValidator",
    attrs: {
      rules: _vm.validationRules,
      name: _vm.validatorName,
      vid: _vm.validatorName,
      immediate: "",
      tag: "div",
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ errors }) {
          return [
            _c(
              "div",
              {
                class: [
                  { "error-styles": errors[0] },
                  { "disabled-field": _vm.disabled },
                  "lf-numeric-container",
                  _vm.percentage ? "lf-percentage-container" : "",
                ],
              },
              [
                _vm.label
                  ? _c(
                      "div",
                      { staticClass: "label-container" },
                      [
                        _c("div", { staticClass: "label-text" }, [
                          _vm._v(_vm._s(_vm.label)),
                        ]),
                        _vm.requiredField
                          ? _c("span", { staticClass: "required-field" }, [
                              _vm._v("*"),
                            ])
                          : _vm._e(),
                        _vm.showInfo
                          ? _c(
                              "v-tooltip",
                              {
                                attrs: { top: "", color: "primary", dark: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "span",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  class: [
                                                    _vm.icons.info,
                                                    "label-icon",
                                                  ],
                                                },
                                                "span",
                                                attrs,
                                                false
                                              ),
                                              on
                                            )
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "show-info-message" },
                                  [_vm._v(_vm._s(_vm.showInfo))]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _c("ejs-numerictextbox", {
                  ref: "numericTextBox",
                  class: [{ "error-styles": errors[0] }, "lf-numeric-input"],
                  attrs: {
                    id: _vm.id,
                    name: _vm.name,
                    showSpinButton: false,
                    showClearButton: true,
                    placeholder: _vm.placeholder,
                    format: _vm.format,
                    decimals: _vm.decimals,
                    min: _vm.minValue,
                    max: _vm.maxValue,
                    validateDecimalOnType: true,
                    created: _vm.onTextBoxCreated,
                    destroyed: _vm.onTextBoxDestroyed,
                  },
                  on: { blur: _vm.emitValueOnBlur },
                  model: {
                    value: _vm.innerValue,
                    callback: function ($$v) {
                      _vm.innerValue = $$v
                    },
                    expression: "innerValue",
                  },
                }),
                _c("div", { staticClass: "messages-container" }, [
                  errors.length
                    ? _c("span", { staticClass: "alert-message" }, [
                        _vm._v(_vm._s(errors[0])),
                      ])
                    : _c("span", { staticClass: "help-message" }, [
                        _vm._v(_vm._s(_vm.helpText)),
                      ]),
                ]),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }